import { RootState } from '../../../store';
import { AvailabilityRefineOption, AvailabilitySlotDetails } from './slice';

export const selectRefineAvailabilitySelectedOptions = (state: RootState): string[] =>
    state.availability.refineAvailabilitySelectedOptions;
export const selectRefineOptions = (state: RootState): AvailabilityRefineOption[] => state.availability.refineOptions;
export const selectSelectedSlot = (state: RootState): AvailabilitySlotDetails => state.availability.selectedSlot;
